<template>
  <div class="title-recommendations-modal">
    <h2 class="mb-4 text-lg font-semibold text-white">Recommended to You</h2>

    <p class="mb-4 text-sm text-gray-400">
      {{ recommendations.length }} friend{{
        recommendations.length !== 1 ? 's' : ''
      }}
      recommended this title
    </p>

    <div class="space-y-3 max-h-[50vh] overflow-y-auto">
      <div
        v-for="rec in recommendations"
        :key="rec.conversation_id"
        class="recommendation-item"
        @click="openConversation(rec.conversation_id)">
        <div class="flex gap-3 items-start">
          <!-- Sender avatar -->
          <UserAvatar :user="rec.sender" class="size-10 shrink-0" />

          <!-- Content -->
          <div class="flex-1 min-w-0">
            <div class="flex gap-2 justify-between items-center">
              <p class="font-medium text-white">
                {{ rec.sender?.displayname || rec.sender?.username }}
              </p>
              <span class="text-xs text-gray-500 shrink-0">
                {{ formatTime(rec.created_at) }}
              </span>
            </div>

            <p class="text-xs text-gray-400">@{{ rec.sender?.username }}</p>

            <!-- Message -->
            <p v-if="rec.message" class="mt-2 text-sm italic text-gray-300">
              "{{ rec.message }}"
            </p>

            <!-- Review indicator -->
            <div v-if="rec.review" class="flex gap-2 items-center mt-2 text-xs">
              <span
                class="px-2 py-0.5 rounded bg-indigo-500/20 text-indigo-300">
                Shared review
              </span>
              <span v-if="rec.review.score_overall != null" class="text-gray-400">
                Score: {{ formatScore(rec.review.score_overall) }}
              </span>
            </div>
          </div>

          <!-- Arrow -->
          <fa-icon icon="chevron-right" class="mt-3 text-sm text-gray-600" />
        </div>
      </div>
    </div>

    <button
      class="py-3 px-4 mt-6 w-full font-medium text-white bg-gray-700 rounded-xl transition-colors hover:bg-gray-600"
      @click="$emit('close')">
      Close
    </button>
  </div>
</template>

<script setup>
import { useStoreModals } from '@/stores/storeModals'
import UserAvatar from '@/components/UserAvatar.vue'

const props = defineProps({
  titleId: {
    type: String,
    default: null
  },
  recommendations: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['close'])
const storeModals = useStoreModals()

const formatTime = (dateString) => {
  if (!dateString) return ''

  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now - date
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffDays === 0) return 'Today'
  if (diffDays === 1) return 'Yesterday'
  if (diffDays < 7) return `${diffDays}d ago`

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  })
}

const formatScore = (score) => {
  return score != null ? parseFloat(score).toFixed(1) : '-'
}

const openConversation = (conversationId) => {
  emit('close')
  // Small delay to allow modal to close before opening new one
  setTimeout(() => {
    storeModals.openModal({ type: 'Messages', props: { conversationId } })
  }, 150)
}
</script>

<style scoped>
.recommendation-item {
  background: rgba(31, 41, 55, 0.5);
  border: 1px solid rgba(55, 65, 81, 0.5);
  border-radius: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 150ms ease;
}

.recommendation-item:hover {
  background: rgba(55, 65, 81, 0.5);
  border-color: rgba(75, 85, 99, 0.6);
}
</style>
